export enum EMainCategories {
  REPORT = 'Raporty',
  PRESENTATION = 'Ład korporacyjny',
}

export enum EMainCategoriesNIds {
  REPORT = 0,
  PRESENTATION = 1,
}

export const EMainCategoriesLabels: Record<EMainCategories, number> = {
  [EMainCategories.REPORT]: EMainCategoriesNIds.REPORT,
  [EMainCategories.PRESENTATION]: EMainCategoriesNIds.PRESENTATION,
}
